// extracted by mini-css-extract-plugin
export var growableInput = "_6j-0";
export var tagContainer = "_6j-2";
export var textInput = "_6j-1";